// extracted by mini-css-extract-plugin
module.exports = {"images":"ComposeImages__images__FmTqI","image":"ComposeImages__image__6VONS"};